import React  from 'react';
import { styled } from '@mui/styles';
import TabList from '@mui/lab/TabList';

const TabListCustom = styled((props) => <TabList {...props} />)
(({ theme }) => ({
  backgroundColor: theme.palette.default.main,
  '& .MuiTab-root.Mui-selected': {
    color: theme.palette.secondary.main
  },
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.secondary.main
  }
}));

const TabsCustom = (props) => {
    return (
      <TabListCustom {...props} />
    )
}

export default TabsCustom
